interface ReportSectionSavedDetail {
  section_code?: string;
  firma_adi?: string;
  raporlama_yili?: number;
  source?: string;
}

export const notifyReportSectionSaved = (detail: ReportSectionSavedDetail = {}) => {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(new CustomEvent('section-saved', { detail }));
};
